import { useTranslation } from 'react-i18next';

export const BenefitsSection = () => {
  const { t } = useTranslation();

  const leftBenefits = [
    {
      icon: "fa-shield-alt",
      title: t('benefits.antifraud.title'),
      text: t('benefits.antifraud.text'),
      highlight: t('benefits.antifraud.highlight')
    },
    {
      icon: "fa-bolt",
      title: t('benefits.validation.title'),
      text: t('benefits.validation.text'),
      highlight: t('benefits.validation.highlight')
    }
  ];

  const rightBenefits = [
    {
      icon: "fa-hand-holding-usd",
      title: t('benefits.costs.title'),
      text: t('benefits.costs.text'),
      highlight: t('benefits.costs.highlight')
    },
    {
      icon: "fa-globe-americas",
      title: t('benefits.resilience.title'),
      text: t('benefits.resilience.text'),
      highlight: t('benefits.resilience.highlight')
    }
  ];

  return (
    <section id="beneficios" className="py-10 lg:py-20 bg-gray-50 lg:bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        {/* Header */}
        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="font-audiowide text-3xl sm:text-4xl text-[#111111] mb-6">{t('benefits.title')}</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-brand-electric-blue to-brand-neon-green mx-auto rounded-full mb-8"></div>
          <p className="font-montserrat text-gray-500 text-sm max-w-xl mx-auto leading-relaxed">
            {t('benefits.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">

          {/* Left Column */}
          <div className="lg:col-span-3 space-y-12">
            {leftBenefits.map((benefit, index) => (
              <div key={index} className="text-center lg:text-right animate-on-scroll" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="flex items-center justify-center mb-4 mx-auto lg:ml-auto lg:mr-0 text-brand-electric-blue">
                  <i className={`fas ${benefit.icon} text-3xl`}></i>
                </div>
                <h3 className="font-audiowide text-lg text-[#111111] mb-3">{benefit.title}</h3>
                <p className="font-montserrat text-gray-500 text-xs leading-relaxed">
                  {benefit.text} <span className="text-brand-electric-blue font-semibold">{benefit.highlight}</span>
                </p>
              </div>
            ))}
          </div>

          {/* Center Column: Illustration - Hidden on mobile */}
          <div className="hidden lg:flex lg:col-span-6 justify-center py-8 lg:py-0">
            <div className="relative group animate-on-scroll" style={{ animationDelay: '0.2s' }}>
              {/* Background Glow */}
              <div className="absolute inset-0 bg-brand-electric-blue/10 rounded-full blur-[100px] group-hover:bg-brand-electric-blue/20 transition-all duration-700"></div>

              {/* 3D Certificate Image */}
              <div className="relative z-10 animate-float">
                <img
                  src="/images/benefits-center-final.webp"
                  alt="4tlayer Digital Certificate"
                  className="w-full max-w-[450px] drop-shadow-2xl transition-transform duration-500 group-hover:scale-105"
                  style={{ mixBlendMode: 'multiply' }}
                />
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-3 space-y-12">
            {rightBenefits.map((benefit, index) => (
              <div key={index} className="text-center lg:text-left animate-on-scroll" style={{ animationDelay: `${(index + 2) * 0.1}s` }}>
                <div className="flex items-center justify-center mb-4 mx-auto lg:mr-auto lg:ml-0 text-brand-electric-blue">
                  <i className={`fas ${benefit.icon} text-3xl`}></i>
                </div>
                <h3 className="font-audiowide text-lg text-[#111111] mb-3">{benefit.title}</h3>
                <p className="font-montserrat text-gray-500 text-xs leading-relaxed">
                  {benefit.text} <span className="text-brand-electric-blue font-semibold">{benefit.highlight}</span>
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};
